<template>
  <data-table
    :test-id-prefix="`vendas-produtos-${pais}`"
    :config="dataTableConfig"
    :data="linhas"
    :endpoint="null"
    :filterConfig="filterConfig"
    :csvButton="csvButtonConfig">
  </data-table>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { VendasProdutos_ListaRow } from '../../contracts/VendasProdutos_ListaRow';

const props = defineProps<{
  linhas: VendasProdutos_ListaRow[];
  pais: string;
}>();

const { t } = useI18n();

/**
 * As três colunas de dinheiro juntas, nesta ordem, são a decisão do chamado.
 *
 * Mostrar só o líquido faria "Cordón Flat Blanco — 240" parecer um produto
 * vendido abaixo do preço de catálogo, quando na verdade houve um desconto
 * comercial na ORDEM. Quem lê o relatório para decidir preço tiraria a
 * conclusão errada sobre o próprio preço que definiu.
 */
const tableColumns = computed(() => [
  { data: 'produto_nome', title: t('Produto'), width: 220, sortable: true },
  { data: 'franquia_nome', title: t('Franquia'), width: 180, sortable: true },
  { data: 'quantidade', title: t('Qtd'), width: 80, sortable: true, footerType: 'sum' },
  { data: 'ordens', title: t('Ordens'), width: 90, sortable: true, footerType: 'sum' },
  { data: 'bruto', title: t('Bruto'), width: 130, sortable: true, renderType: 'currency', footerType: 'sum' },
  { data: 'desconto', title: t('Desconto'), width: 130, sortable: true, renderType: 'currency', footerType: 'sum' },
  { data: 'liquido', title: t('Líquido'), width: 130, sortable: true, renderType: 'currency', footerType: 'sum' },
  { data: 'ticket_medio', title: t('Ticket médio'), width: 130, sortable: true, renderType: 'currency' },
]);

const dataTableConfig = computed(() => ({
  tableId: `tabelaVendasProdutos_${props.pais}`,
  filename: `vendas_produtos_${props.pais}_${new Date().toISOString().split('T')[0]}`,
  columns: tableColumns.value,
  pageLength: 100,
  pagination: true,
  // O rodapé soma só as linhas DESTE país — é por isso que a tabela é por aba.
  footerLabel: t('Totais do país'),
  resizableColumns: true,
  stripedRows: true,
  showGridlines: true,
  size: 'small',
}));

const filterConfig = computed(() => ({
  searchName: t('Procurar'),
  choosePlaceholder: t('Escolha'),
}));

const csvButtonConfig = computed(() => ({
  name: t('Exportar'),
  filename: `vendas_produtos_${props.pais}`,
}));
</script>
